import { Injectable, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * Объект реализующий оповещение о своем завершении.
 */
@Injectable()
export class ImusDestroyService extends Subject<void> implements OnDestroy {
	ngOnDestroy(): void {
		this.next();
		this.complete();
	}
}
